import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionStepsLogUpdatePayload,
	IActionStepsLogUpdatePayloadDone,
	IActionStepsLogUpdatePayloadError,
} from './types';

export const stepsLogUpdate = actionCreatorAsync<
	IActionStepsLogUpdatePayload,
	IActionStepsLogUpdatePayloadDone,
	IActionStepsLogUpdatePayloadError
>(
	'stepsLogUpdate',
	async (params) => {
		const { stepsLog } = params;
		const { id, ...body } = stepsLog;
		const { data } = await Api.stepsLog.update({
			params: { id },
			body,
		});

		return data;
	},
);
